import Keycloak, { KeycloakInitOptions } from 'keycloak-js'
import { URLS } from '@assets/environment/urls'
import { ROUTES } from '@shared/constants/routes'
import { getAuthCallbackUrl, isNativeAuthPlatform } from '@shared/lib/authRedirect'

const getKeycloakConfig = () => {
	if (!URLS.KC_URL || !URLS.KC_REALM || !URLS.KC_USER) {
		throw new Error('Keycloak env config is incomplete')
	}

	return {
		url: URLS.KC_URL,
		realm: URLS.KC_REALM,
		clientId: URLS.KC_USER,
	}
}

let keycloakInstance: Keycloak | null = null

export const getKeycloak = (): Keycloak => {
	if (!keycloakInstance) {
		keycloakInstance = new Keycloak(getKeycloakConfig())
	}

	return keycloakInstance
}

export const getKeycloakInitOptions = (
	extraOptions?: Partial<KeycloakInitOptions>
): KeycloakInitOptions => {
	const baseOptions: KeycloakInitOptions = isNativeAuthPlatform()
		? {
				pkceMethod: 'S256',
				checkLoginIframe: false,
				redirectUri: getAuthCallbackUrl(ROUTES.auth.enterBaseInfo),
			}
		: {
				pkceMethod: 'S256',
				checkLoginIframe: true,
				silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
				redirectUri: window.location.origin + ROUTES.auth.enterBaseInfo,
			}

	return {
		...baseOptions,
		...extraOptions,
	}
}
